import equipmentTypeMemo from "./equipment-type-memo"

export default {

    namespaced: true,

    modules: {
        equipmentTypeMemo
    },

}
